import React from 'react';
import { accessibilityStringifyDates } from '../service/service'
import { getAllParams } from '../service/utils';

const AccessibilityDate = ({ children, eventFromDate, ...params }) => {

    const description = accessibilityStringifyDates(eventFromDate);
    const accessibilityParams = getAllParams(params);

    return React.Children.map(children, (child) => {
        if (typeof child === 'string') {
            return <span {...accessibilityParams} aria-label={description}>{child}</span>;
        } else if (React.isValidElement(child)) {
            return React.cloneElement(child, {
                ...accessibilityParams,
                'aria-label': description,
            });
        }
        return child;
    });
}

export default AccessibilityDate;